import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useHistory } from 'react-router-dom';
import { client } from '../../../hooks/Client';
import Location from '../../../hooks/Location';
import { CHART_MARK_STROKE, CHART_MARK_STROKE_WIDTH } from '../../../helpers/chartPalette';
import useChartColors from '../../../hooks/useChartColors'

const AbsentBar = (props) => {
  const { x, y, width, height } = props;
  if (!height || height <= 0) return null;
  return (
    <rect
      x={x}
      y={y}
      width={width}
      height={height}
      fill="transparent"
      stroke="rgb(32, 108, 127)"
      strokeWidth={2}
      strokeDasharray="6 3"
      style={{ cursor: 'pointer' }}
    />
  );
};

const MixedBarChart = ({data, customTooltip}) => {

  // Hooks
  const history = useHistory()
  const personaId = Location()[3]
  const { palette } = useChartColors()
  const primairyColor = palette[0]
  const secundairyColor = palette[1]

  return (
    <ResponsiveContainer width="100%" height={400}>
        <BarChart
          width={500}
          height={300}
          data={data || []}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip content={customTooltip} />
          <Legend />
          <Bar dataKey="Aanwezigheid" stackId="a" fill={'#47acc3'} onClick={(data) => history.push(`/${client}/personapresencereportdetail/${personaId}/${data.id}`)} stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH} />
          <Bar dataKey="Geroosterd" stackId="a" fill={'#206c7f'} onClick={(data) => history.push(`/${client}/personapresencereportdetail/${personaId}/${data.id}`)} stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH} />
          <Bar dataKey="Afwezig" stackId="a" shape={<AbsentBar />} onClick={(data) => history.push(`/${client}/personapresencereportdetail/${personaId}/${data.id}`)} stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH} />
        </BarChart>
      </ResponsiveContainer>
  )
}

export default MixedBarChart